import { css } from 'styled-components'

export const CustomerSelector = css`
  white-space: nowrap;
`
